import { Injectable } from "@angular/core";

function _window(): Window {
    return window;
}

@Injectable()
export class WindowRef {

    get nativeWindow(): Window {
        return _window();
    }

    setLocationHref(url: string): void {
        this.nativeWindow.location.href = url;
    }

    open(url: string, target: string): Window | null {
        // SECURITY: Set noopener and noreferrer to prevent tabnabbing
        // noopener: Prevents the new page from accessing window.opener
        // noreferrer: Prevents the browser from sending the referrer header
        const windowFeatures = 'noopener,noreferrer';
        const newWindow = this.nativeWindow.open(url, target, windowFeatures);
        
        // Additional protection: manually set opener to null as fallback
        if (newWindow) {
            newWindow.opener = null;
        }
        
        return newWindow;
    }

    getPathname(): string {
        return this.nativeWindow.location.pathname;
    }

    getSearch(): string {
        return this.nativeWindow.location.search;
    }

    getHostname(): string {
        return this.nativeWindow.location.hostname;
    }

    isOnline(): boolean {
        return this.nativeWindow.navigator.onLine;
    }

    isHighDensityDisplay(): boolean {
        return this.nativeWindow.devicePixelRatio > 1
    }

    getScreenHeight(): number {
        return this.nativeWindow.screen.height;
    }
}
